import { createTheme } from "@mui/material";

export default createTheme({
    palette: {
        primary: {
            main: 'rgb(33,78,201)'
        },
        secondary: {
            main: 'rgb(75, 164, 83)'
        }
    }
});